<script setup>
</script>
<template>
    <svg class="svg-defs" style="position: absolute; width: 0; height: 0; overflow: hidden;" xmlns="http://www.w3.org/2000/svg">
        <defs>

            <symbol id="svg-info" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
            <g fill="currentColor" transform="translate(0, 0) scale(1, 1) "><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></g>
            </symbol>

            <symbol id="svg-close" viewBox="0 0 44.47 44.47" preserveAspectRatio="xMidYMid meet" fill="currentColor">
            <polygon class="d" points="44.47 2.04 42.43 0 22.24 20.19 2.04 0 0 2.04 20.19 22.24 0 42.43 2.04 44.47 22.24 24.28 42.43 44.47 44.47 42.43 24.28 22.24 44.47 2.04"/>
            </symbol>

            <symbol id="svg-arrow-up--orig" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" fill="currentColor">
            <g transform="translate(0, 0) scale(1, 1) "><path d="M12,20c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20 M12,22c5.52,0,10-4.48,10-10c0-5.52-4.48-10-10-10 C6.48,2,2,6.48,2,12C2,17.52,6.48,22,12,22L12,22z M11,12l0,4h2l0-4h3l-4-4l-4,4H11z"/></g>
            </symbol>

            <symbol id="svg-arrow-up" viewBox="0 0 20 20" preserveAspectRatio="xMidYMid meet" fill="currentColor">
            <path d="M20,10 C20,4.48 15.52,0 10,0 C4.48,0 0,4.48 0,10 C0,15.52 4.48,20 10,20 C15.52,20 20,15.52 20,10 Z" id="Path" fill="currentColor" fill-rule="nonzero"></path>
            <circle id="Oval" fill="#fff" fill-rule="nonzero" cx="10" cy="10" r="8"></circle>
            <polygon id="Path" fill="currentColor" fill-rule="nonzero" points="9 10 9 14 11 14 11 10 14 10 10 6 6 10"></polygon>
            </symbol>

            <symbol id="svg-star" viewBox="0 0 96 96" preserveAspectRatio="xMidYMid meet" fill="currentColor">
                <polygon fill-rule="nonzero" points="48 77.1536842 77.664 96 69.792 60.48 96 36.5810526 61.488 33.4989474 48 2.13162821e-14 34.512 33.4989474 0 36.5810526 26.208 60.48 18.336 96"></polygon>
            </symbol>

            <symbol id="svg-view-timetable--compact" viewBox="0 0 96 96" preserveAspectRatio="xMidYMid meet" fill="currentColor">
                <polygon points="0 18 18 18 18 0 0 0"></polygon>
                <polygon points="26 18 44 18 44 0 26 0"></polygon>
                <polygon points="52 18 70 18 70 0 52 0"></polygon>
                <polygon points="78 18 96 18 96 0 78 0"></polygon>
                <polygon points="0 44 18 44 18 26 0 26"></polygon>
                <polygon points="26 44 44 44 44 26 26 26"></polygon>
                <polygon points="52 44 70 44 70 26 52 26"></polygon>
                <polygon points="78 44 96 44 96 26 78 26"></polygon>
                <polygon points="0 96 18 96 18 78 0 78"></polygon>
                <polygon points="26 96 44 96 44 78 26 78"></polygon>
                <polygon points="52 96 70 96 70 78 52 78"></polygon>
                <polygon points="78 96 96 96 96 78 78 78"></polygon>
                <polygon points="0 70 18 70 18 52 0 52"></polygon>
                <polygon points="26 70 44 70 44 52 26 52"></polygon>
                <polygon points="52 70 70 70 70 52 52 52"></polygon>
                <polygon points="78 70 96 70 96 52 78 52"></polygon>
            </symbol>

            <symbol id="svg-view-timetable--large" viewBox="0 0 96 96" preserveAspectRatio="xMidYMid meet" fill="currentColor">
                <polygon points="0 28 28 28 28 0 0 0"></polygon>
                <polygon points="34 28 62 28 62 0 34 0"></polygon>
                <polygon points="68 28 96 28 96 0 68 0"></polygon>
                <polygon points="0 96 28 96 28 68 0 68"></polygon>
                <polygon points="34 96 62 96 62 68 34 68"></polygon>
                <polygon points="68 96 96 96 96 68 68 68"></polygon>
                <polygon points="0 62 28 62 28 34 0 34"></polygon>
                <polygon points="34 62 62 62 62 34 34 34"></polygon>
                <polygon points="68 62 96 62 96 34 68 34"></polygon>
            </symbol>

            <symbol id="svg-view-list" viewBox="0 0 96 96" preserveAspectRatio="xMidYMid meet" fill="currentColor">
                <path d="M0,0 L0,16 L96,16 L96,0 L0,0 Z M0,27 L0,43 L96,43 L96,27 L0,27 Z M0,53 L0,69 L96,69 L96,53 L0,53 Z M0,80 L0,96 L96,96 L96,80 L0,80 Z" fill-rule="nonzero"></path>
            </symbol>

            <symbol id="svg-view-search-list" viewBox="0 0 96 96" preserveAspectRatio="xMidYMid meet" fill="currentColor">
                <path d="M0,0 L0,16 L31,16 L31,0 L0,0 Z M0,27 L0,43 L19,43 L19,27 L0,27 Z M0,53 L0,69 L31,69 L31,53 L0,53 Z M0,80 L0,96 L75,96 L75,80 L0,80 Z" id="Shape" fill-rule="nonzero"></path>
                <g id="manage_search" transform="translate(-5.000000, -0.153846)" fill-rule="nonzero">
                    <path d="M94.1615,74.1538462 L75.586,55.5930769 C71.706,58.1130769 67.147,59.6153846 62.2,59.6153846 C48.814,59.6153846 37.95,48.76 37.95,35.3846154 C37.95,22.0092308 48.814,11.1538462 62.2,11.1538462 C75.586,11.1538462 86.45,22.0092308 86.45,35.3846154 C86.45,40.3276923 84.9465,44.8830769 82.4245,48.7115385 L101,67.3207692 L94.1615,74.1538462 Z M76.75,36.3846154 C76.75,28.3884615 70.2025,21.8461538 62.2,21.8461538 C54.1975,21.8461538 47.65,28.3884615 47.65,36.3846154 C47.65,44.3807692 54.1975,50.9230769 62.2,50.9230769 C70.2025,50.9230769 76.75,44.3807692 76.75,36.3846154 Z" id="Shape-Copy"></path>
                </g>
            </symbol>

            <symbol id="svg-filter" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" fill="currentColor">
                <path d="M4.25,5.61C6.27,8.2,10,13,10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-6c0,0,3.72-4.8,5.74-7.39 C20.25,4.95,19.78,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z"/>
            </symbol>

            <symbol id="svg-filter-off" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" fill="currentColor">
                <path d="M19.79,5.61C20.3,4.95,19.83,4,19,4H6.83l7.97,7.97L19.79,5.61z"/><path d="M2.81,2.81L1.39,4.22L10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-2.17l5.78,5.78l1.41-1.41L2.81,2.81z"/>
            </symbol>

            <symbol id="svg-search" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" fill="currentColor">
                <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </symbol>

            <symbol id="svg-manage-search" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" fill="currentColor">
                <path d="M7,9H2V7h5V9z M7,12H2v2h5V12z M20.59,19l-3.83-3.83C15.96,15.69,15.02,16,14,16c-2.76,0-5-2.24-5-5s2.24-5,5-5s5,2.24,5,5 c0,1.02-0.31,1.96-0.83,2.75L22,17.59L20.59,19z M17,11c0-1.65-1.35-3-3-3s-3,1.35-3,3s1.35,3,3,3S17,12.65,17,11z M2,19h10v-2H2 V19z"/>
            </symbol>

            <symbol id="svg-pdf" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" fill="currentColor">
            <path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"/>
            </symbol>

        </defs>
    </svg>
</template>